export type SearchParams = {
  query?: string;
  levels?: string[];
  page?: string;
};

export type FilterProblemsArgs = SearchParams & {
  topicId: number;
  offset?: number;
};

export const SearchParamsArray = ['query', 'levels', 'page'];

export type ProblemClientData = SearchParams & {
  topicId: number;
  totalPagesCount: number;
};
